import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import EntityBlock from '../../EntityBlock';
import getPropsFromEntity from './getPropsFromEntity';

/**
 * A component rendering RFI entity block.
 * @param entity
 * @param env
 * @param region
 * @param projectId
 * @param rest
 * @returns {*}
 * @constructor
 */
const RfiEntityBlock = ({ entity, env, region, projectId, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return <EntityBlock {...getPropsFromEntity({ entity, env, region, projectId, T })} {...rest} />;
};

RfiEntityBlock.propTypes = {
  /**
   * The RFI entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    attributes: PropTypes.shape({
      title: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      identifier: PropTypes.number.isRequired
    })
  }).isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default RfiEntityBlock;
